module.exports = __webpack_public_path__ + "img/the_basics.0d698ed4.svg";